package com.ragnorak.clanybackoffice.di

import com.clany.backoffice.data.repository.NotificationRepositoryImpl
import com.clany.backoffice.domain.repository.NotificationRepository
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides

@ContributesTo(AppScope::class)
interface NotificationsModule {
    @Provides
    fun bindNotificationRepository(impl: NotificationRepositoryImpl): NotificationRepository = impl
}
